<template>
  <div class="main">
    <router-view
      @item-preview="togglePreview"
    />
    <!-- create rename -->
    <van-popup
      class="create-rename-page"
      v-model="showCreateRename"
      position="bottom"
      :lazy-render="false"
      :overlay="false"
    >
      <create-rename
        v-if="showCreateRename"
        :actionName="actionName"
        :actionItem="actionFrom === 'frequent' || $route.params.module === 'select_destination' ? actionItem.item : actionItem"
        :headerItem="headerItem"
        @close-create-rename="toggleCreateRename"
      />
    </van-popup>
    <!-- preview -->
    <van-popup
      class="preview-view"
      v-model="showPreviewView"
      position="right"
      :overlay="false"
    >
      <preview-view
        :show="showPreviewView"
        @close-preview="togglePreview"
        @close-version="toggleVersionView"
        @share-item="sharePreviewItem"
        @toggle-save="handleActionSave"
        :uniqueName="$route.params.unique_name || $route.query.unique_name"
      />
    </van-popup>
    <!-- preview end -->
    <van-popup
      class="move-copy-view"
      v-model="showMoveCopy"
      position="bottom"
    >
      <move-copy
        v-if="showMoveCopy"
        :actionItem="actionFrom === 'frequent' ? actionItem.item : actionItem"
        :actionName="actionName"
        :actionFrom="actionFrom"
      />
    </van-popup>
    <van-popup
      class="share-view"
      v-model="showSharePopup"
      position="bottom"
    >
      <share-popup
        v-if="showSharePopup"
        :actionItem="actionFrom === 'frequent' ? actionItem.item : (actionItem || {})"
        :actionName="actionName"
        :actionFrom="actionFrom"
        :shareActionCategory="shareActionCategory"
        @close-share="handleCloseShare"
      />
        <!-- @close-share="toggleQuery('share')" -->
    </van-popup>
    <!-- comment -->
    <van-popup
      class="comment-view"
      v-model="showComment"
      position="bottom"
    >
      <comment-view
        :show="showComment"
        @close-comment="toggleCommentView"
        @item-preview="togglePreview"
      />
    </van-popup>
    <!-- comment end -->
    <action-sheet
      v-if="!(showComment && !showPreviewView)"
      :actionItem="actionItem"
      :actionFrom="actionFrom"
      :actionName="actionName"
      :actionTitle="actionTitle"
      :actions="actions"
    />
    <!-- sharing -->
    <share-action-popup
      :actionItem="actionItem"
      :actionFrom="actionFrom"
      :actionName="actionName"
      :actionTitle="actionTitle"
      :actions="actions"
      @close-handler="shareCloseCallback"
    />
    <!-- share save -->
    <van-popup
      class="share-save-view"
      v-model="showShareSave"
      position="bottom"
    >
      <file-select
        v-if="showShareSave"
        @dest-change="onTargetChange"
        @close-select="toggleSave"
      >
        <div :class="['btn primary-bgcolor', disableSave && 'disable']" @click="handleSave">{{ $t(`base.save`) }}</div>
      </file-select>
    </van-popup>

    <!-- open in browsers -->
    <van-popup
      class="open-in-browsers"
      v-model="showOpenInBrowers"
    >
      <div v-html="$t('share.cannotOpenLink',[ua.iOS ? 'Safari' : $t('base.browsers')])"></div>
      <i class="iconfont icon-arrow"></i>
    </van-popup>

    <van-dialog class="share-confirm-dialog" v-model="shareConfirmDialog" title="发送给：" show-cancel-button confirm-button-text="分享" @confirm="shareConfirm">
      <div class="share-user-info">
        <!-- <img class="head-img" :src="shareInfo.avatar" /> -->
        <div class="name">{{shareInfo.name}}</div>
      </div>
      <div class="share-file-info">
        {{shareInfo.fileName}}
      </div>
    </van-dialog>

    <wellcome-dialog v-if="showWellcomeDialog" @wellcome-submut="wellcomeSubmit"></wellcome-dialog>
    <register-success v-if="showRegisterSuccess"></register-success>
  </div>
</template>

<script>
import {i18n} from '@/utils/i18n'
import fileActions from '@/utils/fileActions'
import { getActions, infoMap, isShareDisabled, checkIsExternal } from '@/utils/fileUtils'
import ActionSheet from './utils/ActionSheet'
import PreviewView from './preview/PreviewView'
import CreateRename from './file/CreateRename'
import MoveCopy from './file/MoveCopy'
import SharePopup from './share/SharePopup'
import CommentView from './comment/CommentView'
import WellcomeDialog from './guide/WellcomeDialog'
import RegisterSuccess from './guide/RegisterSuccess'
import FileSelect from './file/FileSelect'
import {toast, confirm, ua, pageShare, loadDingTalkIfNeeded, alert, loadFengyunIfNeeded} from '@/utils/common'
import config from '@/config'
import H5Scenario from '@/boot/h5Scenario'
import ShareActionPopup from './share/ShareActionPopup'
import WxApi from '@/utils/WxApi'
import { CREATE_SHARE, GET_INFORE_MEMBER_LIST, GET_SHARE_LINK_PASSWORD, UPDATE_ENTERPRISE_SETTINGS, EDIT_DEPARTMENT_INFO, UPDATE_USER_SETTINGS, EDIT_FILE } from '@/config/api'
import ajax from '@/utils/ajax'

export default {
  name: 'MainView',
  i18n,
  components: {
    ActionSheet,
    CreateRename,
    PreviewView,
    MoveCopy,
    SharePopup,
    CommentView,
    FileSelect,
    ShareActionPopup,
    WellcomeDialog,
    RegisterSuccess
  },
  created () {
    this.showWellcomeDialog = config.user_info && config.user_info.is_admin_of_enterprise && config.enterprise_info && config.enterprise_info.qiyu_info_submit === 1
  },
  mounted () {
    // 如果是在钉钉中，加载钉钉sdk
    loadDingTalkIfNeeded()
    loadFengyunIfNeeded(this.initCordova)
  },
  data () {
    const { query, params } = this.$route
    return {
      module: params.module,
      actionFrom: '',
      actionTitle: '',
      actionName: '',
      actions: [],
      actionItem: {},
      headerItem: {},
      showCreateRename: false,
      showMoveCopy: false,
      showSharePopup: false,
      showComment: !!(query.comment && query.typed_id),
      showPreviewView: !!((query.preview && query.file_id && params.module !== 'share') || params.module === 'open_preview'),
      showShareSave: false,
      saveTarget: {},
      showOpenInBrowers: false,
      ua,
      shareActionCategory: '', // 分享类型
      shareConfirmDialog: false,
      shareInfo: {},
      showWellcomeDialog: false,
      showRegisterSuccess: false
    }
  },
  computed: {
    configs () {
      return config
    },
    disableSave () {
      const permissions = this.saveTarget.permissions || []
      if (this.actionItem.type === 'file') {
        return !permissions.includes('item_upload')
      } else {
        return !permissions.includes('create_folder') && !permissions.includes('item_upload')
      }
    }
  },
  watch: {
    $route (to, from) {
      this.module = to.params.module
      this.showMoveCopy = !!to.query.movecopy
      this.showCreateRename = !!to.query.createrename
      this.showSharePopup = !!to.query.share || !!to.query.invite
      this.showComment = !!(to.query.comment && to.query.typed_id)
      this.showPreviewView = !!((to.query.preview && to.query.file_id) || to.params.module === 'open_preview')
      this.showShareSave = !!to.query.sharesave
    },
    'store.actionSheet' (sheet) {
      if (sheet !== null) {
        this.actionFrom = sheet.actionFrom || this.$route.params.space
        this.actionTitle = sheet.title
        this.actionItem = sheet.actionItem
        if (sheet.actionItem && sheet.actionName !== 'share') {
          this.actions = this.itemActions(sheet.actionItem, sheet.permSave)
        } else if (sheet.actions) {
          this.actions = sheet.actions
        }
        const {shareAction} = this.$route.query

        !shareAction && this.$router.push({ query: {...this.$route.query, actionsheet: 1} })
      } else {
        this.$router.go(-1)
      }
    },
    'store.actionState' (state) {
      switch (state.action) {
        case 'createFolder':
          this.actionName = state.actionName
          this.headerItem = state.headerItem
          this.toggleCreateRename()

          break

        case 'sharesave':
          this.actionItem = state.actionItem
          this.toggleSave()

          break

        case 'downloadInWechat':
          if (!this.showOpenInBrowers) {
            this.showOpenInBrowers = true
          }
          break

        default:
          break
      }
    }
  },
  methods: {
    initCordova () {
      console.log('initCordova')
      const _this = this
      window.document.addEventListener('deviceready', function () {
        console.log('window.cordova', window.cordova)
        window.cordova.exec(function (success) {
          _this.setState({navStatus: success})
        }, function (error) {
          alert('Error: ' + error)
        }, 'MideaCommon', 'navStatus', [])
      }, false)
    },
    itemActions (item, permSave) {
      const {sensitive_control_strategy: {is_share_disabled}, isSensitiveInfoDetectEnabled} = config
      const fileItem = this.actionFrom === 'frequent' ? item.item : item || {}
      const menuExclude = []
      if (!permSave) {
        menuExclude.push('save')
      }
      if (this.$route.query.wps_edit) {
        menuExclude.push('edit-online')
      }
      return getActions({
        scenario: this.actionFrom,
        item,
        actionPermissions: fileItem.action_permissions,
        menuExclude: menuExclude
      }).map(action => {
        return {
          className: action,
          key: action,
          name: (action === 'save' && config.product_name) ? i18n.t('base.saveTo', [config.product_name]) : infoMap[action],
          disabled: this.actionDisabled(action, fileItem) === 'true',
          callback: () => {
            this.actionName = action

            switch (action) {
              case 'move':
              case 'copy':
                this.toggleQuery('movecopy')
                break

              case 'rename':
                this.toggleCreateRename()
                break

              case 'view-version':
                this.toggleVersionView(fileItem)
                break

              case 'share':
                if (item.is_share_disabled || (is_share_disabled && fileItem.detect_status === 'detect_invalid' && !checkIsExternal(fileItem) && isSensitiveInfoDetectEnabled)) {
                  isShareDisabled(item, true) ? toast(i18n.t('file.share.disabled.member.only')) : toast(i18n.t('file.share.disabled'))
                  this.$router.go(-1)
                  this.actionName = ''
                } else {
                  this.actions = this.shareActions(this.actionFrom === 'frequent' ? this.actionItem.item : this.actionItem)
                  this.actionTitle = i18n.t('file.share.desinated.via')
                }
                break

              case 'comment':
                let typed_id = `${fileItem.type}_${fileItem.id}`
                this.toggleCommentView(typed_id)
                break

              case 'download':
                // 目前只有分享列表里面有下载
                let extParams = {}

                if (this.actionFrom === 'share') {
                  extParams = {
                    scenario: 'share',
                    shareToken: this.$route.params.unique_name
                  }
                  ajax({
                    url: GET_SHARE_LINK_PASSWORD,
                    data: { unique_name: this.$route.params.unique_name }
                  }).then(result => {
                    if (result && result.success) {
                      fileActions.downloadFile(fileItem, {...extParams, password: result.pass})
                    }
                  })
                } else {
                  fileActions.downloadFile(fileItem, extParams)
                }
                this.$router.go(-1)
                break

              case 'save':
                this.handleActionSave(item)
                break

              case 'edit-online':
                this.handleActionEditOnline(item)
                break

              default:
                fileActions.handleAction(action, fileItem, this.actionFrom, this)
                // const query = { ...this.$route.query }
                // if (query.actionsheet) {
                //   delete query.actionsheet
                //   this.$router.replace({ query })
                // }
                this.$router.go(-1)
                break
            }
          }
        }
      })
    },
    actionDisabled (action, item) {
      const {sensitive_control_strategy: {is_share_disabled, is_download_disabled}, isSensitiveInfoDetectEnabled} = config
      if (action === 'share' && (item.is_share_disabled || (item.detect_status === 'detect_invalid' && is_share_disabled && !checkIsExternal(item) && isSensitiveInfoDetectEnabled))) {
        return 'true'
      } else if (action === 'download' && item.detect_status === 'detect_invalid' && is_download_disabled && !checkIsExternal(item) && isSensitiveInfoDetectEnabled) {
        return 'true'
      }
      return 'false'
    },
    shareActions (item) {
      const { action_permissions } = item
      const actions = []
      if (action_permissions && action_permissions.includes('perm_share_to_colleague')) {
        actions.push({
          key: 'send-to-colleague',
          name: i18n.t('file.share.sendToColleague'),
          callback: this.shareInit('colleague', 'colleague')
        })
      }
      if (action_permissions && action_permissions.includes('perm_share') && !config.viewConfig.isH5HideShareLinkDownload) {
        this.toggleQuery('shareAction')

        // 从企业微信分享到企业微信会话
        if (pageShare.is_wxwork && pageShare.is_support_shareAppMessage) {
          actions.push({
            key: 'enterpriseWechat',
            name: i18n.t('share.EnterpriseWechat'),
            callback: this.shareInit('link', 'EnterpriseWechat')
          })
        }
        // 从企业微信分享到微信
        if (pageShare.is_wxwork && pageShare.is_support_shareWechatMessage) {
          actions.push({
            key: 'Wechat',
            name: i18n.t('share.Wechat'),
            callback: this.shareInit('link', 'Wechat')
          })
        }
        // 从微信小程序分享到微信小程序
        if (config.h5_scenario && config.h5_scenario === H5Scenario.WX_APPLET) {
          actions.push({
            key: 'Wechat',
            name: i18n.t('share.Wechat'),
            callback: function () {
              if (item.type === 'file') {
                WxApi.navigateTo(WxApi.PAGE_SHARE_CREATE, { fileId: item.id })
              } else {
                WxApi.navigateTo(WxApi.PAGE_SHARE_CREATE, { folderId: item.id })
              }
            }
          })
        }
        actions.push({
          key: 'sharing-link',
          name: i18n.t('file.share.sharingLink'),
          callback: this.shareInit('link', 'link')
        })
        if (ua.fengyun) {
          actions.push({
            key: 'sharing-meixin',
            name: i18n.t('file.share.sharingMeiXin'),
            callback: this.shareInit('meixin', 'meixin')
          })
        }
      }
      return actions
    },
    shareInit (actionName, shareActionCategory) {
      if (shareActionCategory === 'meixin') {
        return () => {
          this.shareMeiXin()
        }
      }
      return () => {
        this.toggleQuery('share')
        this.actionName = actionName
        this.shareActionCategory = shareActionCategory
      }
    },
    shareMeiXin () {
      const _this = this
      if (!ua.fengyun) {
        return
      }
      this.$router.go(-1)
      const fileInfo = this.actionItem.item ? this.actionItem.item : this.actionItem
      const body = {
        fileId: fileInfo.id,
        fileName: fileInfo.name,
        fileSize: fileInfo.size,
        parentId: fileInfo.parent ? fileInfo.parent.id : fileInfo.parent_folder_id
      }
      window.cordova.exec(function (userInfo) {
        window.cordova.exec(function (success) {
          if ((success.users || []).length === 0 && (success.groups || []).length === 0) {
            return
          }
          const isPrivateChat = success.users && success.users.length > 0
          const msgs = [{
            sessionType: isPrivateChat ? 0 : 1,
            toId: isPrivateChat ? success.users[0].uid : success.groups[0].team_id,
            body: body,
            push: '[网盘文件]' + fileInfo.name,
            type: 1,
            subType: 333,
            toAppKey: ''
          }]
          _this.shareInfo = {
            name: isPrivateChat ? (success.users[0].cn || success.users[0].en) : success.groups[0].name, // 选中用户昵称
            fileName: '[网盘文件]' + fileInfo.name,
            msgs: msgs,
            typed_id: fileInfo.typed_id,
            invited_user_ids: []
          }
          if (!isPrivateChat) {
            // 获取群组所有成员id
            let requestUrl = `${GET_INFORE_MEMBER_LIST}?from=${userInfo.uid}&group_id=${success.groups[0].team_id}`
            ajax({
              url: requestUrl,
              parser: res => {
                if (res.member_list && res.member_list.length > 0) {
                  res.member_list.forEach(member => {
                    _this.shareInfo.invited_user_ids.push(member.account)
                  })
                }
              }
            })
          } else {
            _this.shareInfo.invited_user_ids = [success.users[0].uid]
          }
          _this.shareConfirmDialog = true
        }, function (error) {
          alert('error: ' + error)
        }, 'Organization', 'transformSelector', [{ chooseMe: false, min: 1, max: 1, indexTitle: '分享' }])
      }, function (error) {
        alert('Error: ' + error)
      }, 'MideaUser', 'getUser', [])
    },
    shareCloseCallback () {
      this.actionName = ''
    },
    toggleCreateRename () {
      if (this.$route.name === 'OpenView') {
        this.showCreateRename = !this.showCreateRename
      } else {
        this.toggleQuery('createrename')
      }
    },
    togglePreview (item, closeVersion) {
      let otherQuery = { file_id: item ? item.id : undefined }
      // 同时关闭 preview 和 version，后退两步
      this.toggleQuery('preview', otherQuery, closeVersion && (-2))
    },
    toggleVersionView (item) {
      this.toggleQuery('tab', { tab: item ? 'version' : undefined })
    },
    toggleCommentView (typed_id) {
      let otherQuery = { typed_id }
      this.toggleQuery('comment', otherQuery)
    },
    sharePreviewItem (item) {
      this.actionName = 'share'
      this.setState({actionSheet: {
        actions: this.shareActions(item),
        actionFrom: 'preview',
        actionItem: item,
        actionName: 'share',
        title: i18n.t('file.share.desinated.via')
      }})
    },
    onTargetChange (item) {
      this.saveTarget = item
    },
    handleActionSave (item) {
      // 触发保存操作 当前一定为 /h5/share/xxx 登陆后重定向不需要加域名
      if (!(config.user_info && config.user_info.id)) {
        this.toggleQuery('actionsheet')
        confirm({
          className: 'login-fail-dialog',
          message: i18n.t('share.action.needLogin')
        }).then(() => {
          window.location.href = config.loginUrl + '?redirect=' + encodeURIComponent(document.location.pathname)
        })
      } else {
        this.setState({actionState: {
          action: 'sharesave',
          actionItem: item
        }})
      }
    },
    toggleSave () {
      // 触发文件选择器
      this.toggleQuery('sharesave')
    },
    handleSave () {
      // 点击保存按钮
      if (this.disableSave) {
        toast.fail(i18n.t('base.noPermission'))
        return
      }
      const {type, id} = this.actionItem
      fileActions.handleMoveCopy('save', {
        item_typed_ids: `${type}_${id}`,
        target_folder_id: this.saveTarget.isDepartment || this.saveTarget.id === undefined ? 0 : this.saveTarget.id,
        department_id: this.saveTarget.isDepartment ? this.saveTarget.id : undefined
      }).then(res => {
        if (res.error_type === 'item' || res.success) {
          this.toggleSave()
        }
      })
    },
    handleCloseShare () {
      this.$router.go(-2)
    },
    shareConfirm () {
      ajax({
        url: '/apps/users/exchange_user?user_tickets=' + this.shareInfo.invited_user_ids.join(','),
        parser: res => {
          const userIdList = []
          if (res.users && res.users.length > 0) {
            res.users.forEach(member => {
              userIdList.push(member.user_id)
            })
            let data = {
              access: 'collaborators',
              current_version: true,
              description: '',
              disable_download: true,
              due_time: 0,
              password_protected: false,
              group_ids: [],
              invited_user_ids: userIdList,
              item_typed_id: this.shareInfo.typed_id,
              is_preview_limit: false,
              is_download_limit_v2: false
            }
            ajax({
              data,
              url: CREATE_SHARE,
              parser: res => {
                const shareUrl = `https://idisk.infore.com/sso/login?redirect=/h5/share/${res.share_link.unique_name}`
                this.shareInfo.msgs.forEach(element => {
                  if (element.subType === 333) {
                    element.body.shareUrl = shareUrl
                  }
                })
                window.cordova.exec(function (result) {
                  toast(i18n.t('file.share.success'))
                  console.debug(result)
                }, function (error) {
                  console.debug(error)
                }, 'ImPlugin', 'send', [this.shareInfo.msgs])
              }
            })
          }
        }
      })
    },
    handleActionEditOnline (item) {
      const { params = {} } = this.$route

      const file = this.actionFrom === 'frequent' ? item.item : item || {}
      let data = { wps_edit: true, file_id: file ? file.id : undefined }

      if (params.unique_name) {
        data.unique_name = params.unique_name
      }

      this.toggleQuery('preview', data)
    },
    wellcomeSubmit (name, scale, scaleValue, professionItem) {
      const promiseList = [
        ajax({
          url: UPDATE_ENTERPRISE_SETTINGS,
          data: {
            name,
            qiyu_scale: scaleValue,
            qiyu_info_submit: 0,
            register_industry_info: professionItem
          }
        }),
        ajax({
          url: EDIT_DEPARTMENT_INFO,
          data: {
            department_id: config.wellcomeDeptId,
            director_id: config.user_info.id,
            department_name: name
          }
        }),
        ajax({
          url: UPDATE_USER_SETTINGS,
          data: {
            name: scale === 'personal' ? name : '管理员'
          }
        })
      ]

      if (config.wellcomeFolderInfo && config.wellcomeFolderInfo.typed_id) {
        promiseList.push(ajax({
          url: EDIT_FILE,
          data: {
            item_typed_id: config.wellcomeFolderInfo.typed_id,
            name: `${name}共享资料`
          }
        }))
      }
      Promise.all(promiseList).then((values) => {
        if (values.every(item => item.success)) {
          this.showWellcomeDialog = false
          this.showRegisterSuccess = true
          // window.location.reload()
        }
      })
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (this.selectListStack.length) {
      if (to.query.selectnav || from.query.selectnav || to.query.createfolder || from.query.createfolder) {
        next()
      } else if (this.selectListStack.length === 1) {
        this.selectListStack = []
        next()
      } else {
        this.selectListStack.pop()
        next(false)
      }
    } else {
      next()
    }
  }
}
</script>

<style lang="postcss">
@import 'variables';

.main {
  height: 100%;
  width: 100%;

  & .create-rename-page,
  & .preview-view,
  & .version-list,
  & .move-copy-view,
  & .share-view,
  & .change-perms-view,
  & .add-message-view,
  & .comment-view,
  & .contact-select-view,
  & .contact-remove-view,
  & .share-save-view  {
    width: 100%;
    height: 100%;
  }

  & .preview-view {
    background-color: #38393a;
  }

  & .version-list,
  & .comment-view {
    background-color: #eeeff5;
  }

  & .open-in-browsers {
    width: 100%;
    top: 0;
    left: 0;
    padding: 44px 0 34px;
    transform: none;
    font-size: 16px;
    color: #4e5660;
    text-align: center;

    & div {
      display: inline-block;
      text-align: left;
      max-width: 80%;
    }

    & .bold {
      color: #252e36;
      font-weight: bold;
    }

    & i {
      position: absolute;
      top: 4px;
      right: 16px;
      font-size: 48px;
      color: #b2b7cb;
    }
  }
}
.share-confirm-dialog .van-dialog__header{
  text-align: left;
  padding-left: 20px;
}
.share-confirm-dialog .van-dialog__content{
  text-align: left;
  padding:10px 20px 20px 20px;
}
.share-confirm-dialog .van-dialog__content .share-user-info{
  display: flex;
}
.share-confirm-dialog .van-dialog__content .share-file-info{
  margin-top: 10px;
  font-size: 14px;
  color: #979799;
}
</style>
